<mat-toolbar color="primary" class="admin-toolbar mat-elevation-z2">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
        <div fxLayout="row" fxLayoutAlign="center center">
            <div class="logo-section" fxShow="false" fxShow.gt-xs>
                <a routerLink="/compte-utilisateur">
                    <app-logo></app-logo>
                </a>
            </div>
            <button mat-icon-button (click)="toggleSidenav()">
                <mat-icon>menu</mat-icon>
            </button>
            <button fxShow="false" fxShow.gt-xs mat-icon-button
                (click)="settings.adminSidenavUserBlock = !settings.adminSidenavUserBlock">
                <mat-icon>person</mat-icon>
            </button>
            <a mat-icon-button routerLink="/">
                <mat-icon>home</mat-icon>
            </a>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center">
            <div fxLayout="row" fxLayoutAlign="end center">
                <a mat-button (click)="changeTypeAccount()" matTooltip="Basculer en tant que {{userDetails.roleApp=='locataire' ? 'Propriètaire' : 'Locataire'}}">
                    <span fxShow="false" fxShow.gt-sm class="mx-1 uppercase">{{userDetails.roleApp}}</span> 
                    <mat-icon class="mat-icon caret">autorenew</mat-icon>
                </a>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxShow="false" fxShow.gt-xs class="search-bar">
                <form method="get">
                    <input type="text" placeholder="Type to search..." class="mat-elevation-z3"
                        [class.show]="toggleSearchBar">
                    <button mat-icon-button (click)="toggleSearchBar = !toggleSearchBar" type="button">
                        <mat-icon>search</mat-icon>
                    </button>
                </form>
            </div>
            <app-lang></app-lang>
            <app-fullscreen></app-fullscreen>
            <app-messages fxShow="false" fxShow.gt-xs></app-messages>
            <app-user-menu></app-user-menu>
        </div>
    </div>
</mat-toolbar>
<mat-drawer-container class="admin-container">
    <mat-drawer #sidenav [opened]="settings.adminSidenavIsOpened"
        [mode]="(settings.adminSidenavIsPinned) ? 'side' : 'over'" class="admin-sidenav mat-elevation-z6"
        autoFocus="false">
        <perfect-scrollbar>
            <div fxLayout="column" fxLayoutAlign="center center" class="user-block transition-2"
                [class.show]="settings.adminSidenavUserBlock">
                <div fxLayout="row" fxLayoutAlign="space-around center" class="user-info-wrapper">
                    <img alt="profile image" src={{src+UserImage}} width="50" *ngIf="elementImage">
                    <img [src]="UserImage" alt="user-image" *ngIf="!elementImage">
                    <div class="user-info">
                        <p class="name">
                            <small>
                                <span *ngIf="userDetails?.user_name">{{userDetails?.user_name}}<br></span>
                                <span *ngIf="userDetails?.user_phone">{{userDetails?.user_phone}}<br></span>
                                <span *ngIf="userDetails?.email" style="font-size: x-small;">{{userDetails?.email}}</span>
                            </small>
                        </p>
                        <p class="position">Inscrit dépuis le <br> <small class="muted-text">{{userDetails?.created_at | date:"dd MMMM, yyyy 'a' HH:mm" }}</small></p>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutAlign="space-around center" class="w-100 muted-text">
                    <button mat-icon-button routerLink="/compte-utilisateur/mon-compte/verification-compte">
                        <mat-icon>person_outline</mat-icon>
                    </button>
                    <button mat-icon-button [matMenuTriggerFor]="menu">
                        <mat-icon *ngIf="messages.length > 0"  matBadge="{{messages.length}}" matBadgeColor="warn">mail_outline</mat-icon>
                        <mat-icon *ngIf="messages.length <= 0">mail_outline</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item routerLink="/compte-utilisateur/message/locataire">Locataire</button>
                        <button mat-menu-item routerLink="/compte-utilisateur/message/proprietaire">Propriètaire</button>
                    </mat-menu>

                    <!-- <button mat-icon-button routerLink="/compte-utilisateur/message">
                         
                             <mat-icon *ngIf="messages.length > 0"  matBadge="{{messages.length}}" matBadgeColor="warn">
                                mail_outline</mat-icon>
                        <mat-icon *ngIf="messages.length <= 0">mail_outline</mat-icon>
                    </button> -->

                    <button mat-icon-button (click)="logout()">
                        <mat-icon>power_settings_new</mat-icon>
                    </button>
                </div>
            </div>
            <app-admin-menu [menuItems]="menuItems" [menuParentId]="0"></app-admin-menu>
        </perfect-scrollbar>
    </mat-drawer>
    <mat-drawer-content>
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>